import { Form, FormInstance } from 'antd'
import { AxiosResponse } from 'axios'
import Typography from 'components/Typography/Typography'
import Switch from 'components/Switch/Switch'
import { LABELS } from 'constants/txt'
import { ResponseWithPagination } from 'constants/index'
import { CustomForm } from 'components/Forms/CustomForm'
import { validateMessages } from 'helper/common'
import { AddSignatorySelect } from '../AddSignatoryPopup/AddSignatorySelect'
import { TSignatoryUserOption } from '../AddSignatoryPopup/types'
import { useEffect } from 'react'
import { Attachment } from 'components/Attachment/Attachment'
import cn from 'classnames'

export type TConfigureContractSectionProps = {
  file: File
  form?: FormInstance
  optionsRequest: () => Promise<
    AxiosResponse<ResponseWithPagination<TSignatoryUserOption>>
  >
  className?: string
  onFormReady?: (form: FormInstance) => void
  onDelete: () => void
}

export const ConfigureContractSection = ({
  file,
  form: formProp,
  optionsRequest,
  className,
  onFormReady,
  onDelete
}: TConfigureContractSectionProps) => {
  const [internalForm] = Form.useForm()
  const form = formProp ?? internalForm

  useEffect(() => {
    onFormReady?.(form)
    // intentionally omit onFormReady — register once per form instance
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form])

  const signatorySwitch = Form.useWatch('signatorySwitch', form)

  // TODO: do not remove for now - it will be needed

  return (
    <CustomForm
      form={form}
      noValidate={true}
      initialValues={{
        redliningSwitch: false,
        signatorySwitch: false
      }}
      validateMessages={{
        ...validateMessages,
        types: {
          email: 'Enter a valid email'
        }
      }}
    >
      <div className={cn('configure-contract-section-container', className)}>
        <div className="configure-contract-section-container__header">
          <Attachment
            className="configure-contract-section-container__attachment"
            link={URL.createObjectURL(file)}
            filename={file.name}
            onDelete={onDelete}
          />
        </div>
        <div className="column gap-8 p-16">
          <div className="row gap-24 align-center align-start justify-start">
            <Form.Item name="redliningSwitch" valuePropName="checked" noStyle>
              <Switch withLabels />
            </Form.Item>
            <div className="column">
              <Typography.Body1 className="notifications-setup__left-column">
                Redlining
              </Typography.Body1>
              <Typography.Label className="gray-text">
                Allow parties to exchange marked-up versions before finalizing.
              </Typography.Label>
            </div>
          </div>
          <div className="row gap-24 align-center align-start justify-start">
            <Form.Item name="signatorySwitch" valuePropName="checked" noStyle>
              <Switch withLabels />
            </Form.Item>
            <div className="column">
              <Typography.Body1 className="notifications-setup__left-column">
                In-app digital signing
              </Typography.Body1>
              <Typography.Label className="gray-text">
                Require a signature before the contract is considered executed.
              </Typography.Label>
            </div>
          </div>
          {signatorySwitch && (
            <AddSignatorySelect
              form={form}
              className="signatory-select"
              phoneNumberFieldName="phoneNumber"
              selectPropsItem={{
                label: LABELS.SIGNATORY,
                name: 'signatory'
              }}
              optionsRequest={optionsRequest}
            />
          )}
        </div>
      </div>
    </CustomForm>
  )
}
